<template>
<span>
    <v-layout mb-4>
        <v-flex xs10 ml-3>
            <h2 class="lime--text lighten-1 pt-3">Gerenciar Arquivos - {{ download_category.down_c_nome }}</h2>
        </v-flex>
        <v-flex xs2 mr-3 text-right>
            <v-btn color="blue-grey" class="black--text" :to="{name: 'download-categories'}">
                <v-icon dark>keyboard_arrow_left</v-icon>
                Voltar
            </v-btn>
        </v-flex>
    </v-layout>

    <galeria-download-category-file v-on:atualiza="loadDownloadCategoryWithFiles" :download_category="download_category"></galeria-download-category-file>

</span>
</template>

<script>
import GaleriaDownloadCategoryFileComponent from "./partial/GaleriaDownloadCategoryFileComponent";

export default {
    name: "AddDownloadFileComponent",
    created() {
        this.loadDownloadCategoryWithFiles()
    },
    props: {
        down_c_id: {
            require: true
        }
    },
    data() {
        return {
            download_category: {},
            btnLabel: 'Salvar',
        }
    },
    methods: {
        loadDownloadCategoryWithFiles() {
            this.$store.dispatch('loadDownloadCategoryWithFiles', this.down_c_id)
                .then(response => this.download_category = response)
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: 'Erro',
                        text: 'Dados não localizado',
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
        },
    },
    components: {
        GaleriaDownloadCategoryFile: GaleriaDownloadCategoryFileComponent,
    }
};
</script>

<style scoped>

</style>
